import { DBServiceOptionsWithImagesAndValidation } from '../../../../types/dbService';
import { ContactModel } from '../../../../types/Contacts';
import { EventContactModel } from '../../../../types/EventContact';
import { EventContactReminderModel } from '../../../../types/EventContactReminder';
import { HorseContactModel } from '../../../../types/HorseContact';
import { DBWriterLoggerFunction } from '../../../../types/logger';
import EventContact from '../../EventContact';
import EventContactReminder from '../../EventContactReminder';
import HorseContact from '../../HorseContact';

export const prepareDeleteContact = ({
    contactElement,
}: {
    contactElement: ContactModel;
}) => contactElement.prepareMarkAsDeleted();

export const prepareDeleteHorseContacts = async ({
    contactId,
    shouldDelete,
    serviceOptions,
}: {
    contactId: string;
    shouldDelete: boolean;
    serviceOptions: DBServiceOptionsWithImagesAndValidation;
}): Promise<HorseContactModel[]> => {
    if (!shouldDelete) return [];

    const horseContactService = new HorseContact(serviceOptions);
    const horseContacts = await horseContactService.getByParam(
        'contact_id',
        contactId,
    );

    return horseContacts.map((horseContact) =>
        horseContact.prepareMarkAsDeleted(),
    );
};

export const prepareDeleteEventContacts = async ({
    contactId,
    shouldDelete,
    serviceOptions,
}: {
    contactId: string;
    shouldDelete: boolean;
    serviceOptions: DBServiceOptionsWithImagesAndValidation;
}): Promise<{
    eventContactsToDelete: EventContactModel[];
    eventContactRemindersToDelete: EventContactReminderModel[];
}> => {
    const eventContactsToDelete: EventContactModel[] = [];
    const eventContactRemindersToDelete: EventContactReminderModel[] = [];

    if (!shouldDelete) {
        return { eventContactsToDelete, eventContactRemindersToDelete };
    }

    const eventContactService = new EventContact(serviceOptions);
    const eventContactReminderService = new EventContactReminder(
        serviceOptions,
    );
    const eventContacts = await eventContactService.fetchByParam(
        'contact_id',
        contactId,
    );

    for (const eventContact of eventContacts) {
        const eventContactReminders =
            await eventContactReminderService.getByParam(
                'event_contact_id',
                eventContact.id,
            );

        eventContactRemindersToDelete.push(
            ...eventContactReminders.map((eventContactReminder) =>
                eventContactReminder.prepareMarkAsDeleted(),
            ),
        );
        eventContactsToDelete.push(eventContact.prepareMarkAsDeleted());
    }

    return { eventContactsToDelete, eventContactRemindersToDelete };
};

export const logDeleteContactActions = ({
    contactElement,
    horseContactsToDelete,
    eventContactsToDelete,
    eventContactRemindersToDelete,
    logDBAction,
    tableName,
}: {
    contactElement: ContactModel;
    horseContactsToDelete: HorseContactModel[];
    eventContactsToDelete: EventContactModel[];
    eventContactRemindersToDelete: EventContactReminderModel[];
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Delete contact',
        modelName: tableName,
        payload: contactElement,
    });

    if (horseContactsToDelete.length > 0) {
        logDBAction({
            message: 'Delete horse - delete horse contacts',
            modelName: tableName,
            payload: horseContactsToDelete,
        });
    }

    if (eventContactsToDelete.length > 0) {
        logDBAction({
            message: 'Delete contact - delete event contacts',
            modelName: tableName,
            payload: eventContactsToDelete,
        });
    }

    if (eventContactRemindersToDelete.length > 0) {
        logDBAction({
            message: 'Delete contact - delete contact remiders',
            modelName: tableName,
            payload: eventContactRemindersToDelete,
        });
    }
};
